import { render, staticRenderFns } from "./AddOrEditProperties.vue?vue&type=template&id=25e15539&"
import script from "./AddOrEditProperties.vue?vue&type=script&lang=js&"
export * from "./AddOrEditProperties.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditProperties.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports